import ProductoDto from "../models/productoDto";

export const createAdapterProductoHistorial = (endpointHistorial) => {
    return Object.assign(new ProductoDto({}), endpointHistorial);
}